//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is the property of 6over6 Ltd. and its licensors. Any use of the Software is strictly prohibited unless an explicit license or permission is granted by 6over6 Ltd.
import AnalyticsLogger from "../AnalyticsLogger";

const GoToNextPageActionHandler = class GoToNextPageActionHandler {
  async handle(action, store) {
    if (!store) {
      return;
    }
    store.state.page = action.page;
    if (!action.page.mixpanelEvent) {
      return;
    }
    AnalyticsLogger.log(action.page.mixpanelEvent);
  }
};

export default GoToNextPageActionHandler;
